import React, { useEffect } from "react";
import { FlowerSVG } from "./FlowerSVG";
import { initFlowerAnimation } from "./animation";
import "./AnimatedFlower.css";

const AnimatedFlower: React.FC = () => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const cleanup = initFlowerAnimation();
            return () => cleanup && cleanup();
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    return <FlowerSVG />;
};

export default AnimatedFlower;